module.exports = __webpack_public_path__ + "static/media/profile.a7bd12dc.jpg";